module.exports = __webpack_public_path__ + "img/banner.bc22b827.png";